import React from 'react';
import AdminPageHolder from '../AdminPanelsPage/AdminPageHolder';
import Panel from './Panel';

const api = '/api/notifications/custom';

export default () => (
    <AdminPageHolder>
        <h1>User Notifications</h1>
        <Panel api={api} />
    </AdminPageHolder>
);
